export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    header: 'Fiches',
  },
  {
    title: 'Clients',
    route: 'listclient',
    icon: 'UsersIcon',
  },
  {
    title: 'Articles',
    route: 'listarticle',
    icon: 'PackageIcon',
  },
  {
    header: 'Gestion des ventes',
  },
  {
    title: 'Nouvelle commande',
    route: 'newcommande',
    icon: 'PlusSquareIcon',
  },
  {
    title: 'Commandes',
    route: 'listcommande',
    icon: 'ListIcon',
  },
]
